import SEOHead from "../components/seo/SEOHead";

export default function PlaceholderPage({ title, description }) {
  const pageDescription = description || `${title} information from Paras Organics. Explore organic Vermicompost, Vermiwash, plant care, soil health, and natural growing support.`;

  return (
    <>
      <SEOHead
        title={title}
        description={pageDescription}
        path={window.location.pathname}
      />
      <section className="section" aria-label={title}>
        <div className="section-inner" style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
          <div style={{ textAlign: "center", maxWidth: "640px" }}>
            <span className="section-label">Coming Soon</span>
            <h1 className="section-title">{title}</h1>
            <p className="section-desc" style={{ marginLeft: "auto", marginRight: "auto" }}>
              {description || "This page is ready in the routing structure and can be expanded into a full inner page whenever you want."}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
